import { withRouter } from 'react-router-dom'
import * as H from 'history'
import ProtocolVersions from './protocol_versions'

type Props = {
    history: H.History
    title?: string
    onlyQC?: boolean
}

const QcVersionsPage = (props: Props) => {
    return (
        <>
            <ProtocolVersions history={props.history} onlyQC headerTitle="QC設定" route="qc_settings" />
        </>
    )
}

export default withRouter(QcVersionsPage)
